import React, { useEffect } from 'react';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  author?: string;
  publishedTime?: string;
  modifiedTime?: string;
  section?: string;
  tag?: string;
}

const SEO: React.FC<SEOProps> = ({
  title = "Aedon Community | Türkiye'nin En Yeni FiveM Community'si",
  description = "Aedon Community - Türkiye'nin en yeni ve en büyük FiveM community'si. Sunucularımız, oyunlarımız, scriptlerimiz ve premium hizmetlerimizle unutulmaz deneyimler yaşayın.",
  keywords = "Aedon, Aedon Community, Community, FiveM, FiveM Türkiye, FiveM Community, FiveM RP, FiveM Sunucu, FiveM Script, FiveM Oyun, Türkiye FiveM, FiveM Türk, FiveM Server, FiveM Roleplay, FiveM Türkiye Community, Aedon FiveM, Community FiveM, FiveM Türk Community, FiveM Türkiye Server, FiveM Türkiye RP",
  image = "/aedon.png",
  url = "https://aedoncommunity.com",
  type = "website",
  author = "Aedon Community",
  publishedTime,
  modifiedTime,
  section,
  tag
}) => {
  const fullUrl = url.startsWith('http') ? url : `https://aedoncommunity.com${url}`;
  const fullImageUrl = image.startsWith('http') ? image : `https://aedoncommunity.com${image}`;

  useEffect(() => {
    // Title güncelleme
    document.title = title;
    
    // Meta tag'leri güncelleme
    const updateMetaTag = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    const updatePropertyTag = (property: string, content: string) => {
      let meta = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    // Primary Meta Tags
    updateMetaTag('title', title);
    updateMetaTag('description', description);
    updateMetaTag('keywords', keywords);
    updateMetaTag('author', author);
    updateMetaTag('robots', 'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1');
    updateMetaTag('language', 'Turkish');
    updateMetaTag('revisit-after', '1 days');
    updateMetaTag('distribution', 'global');
    updateMetaTag('rating', 'general');

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = fullUrl;

    // Open Graph / Facebook
    updatePropertyTag('og:type', type);
    updatePropertyTag('og:url', fullUrl);
    updatePropertyTag('og:title', title);
    updatePropertyTag('og:description', description);
    updatePropertyTag('og:image', fullImageUrl);
    updatePropertyTag('og:image:width', '1200');
    updatePropertyTag('og:image:height', '630');
    updatePropertyTag('og:site_name', 'Aedon Community');
    updatePropertyTag('og:locale', 'tr_TR');

    // Twitter
    updatePropertyTag('twitter:card', 'summary_large_image');
    updatePropertyTag('twitter:url', fullUrl);
    updatePropertyTag('twitter:title', title);
    updatePropertyTag('twitter:description', description);
    updatePropertyTag('twitter:image', fullImageUrl);

    // Article specific meta tags
    if (type === 'article') {
      if (publishedTime) updatePropertyTag('article:published_time', publishedTime);
      if (modifiedTime) updatePropertyTag('article:modified_time', modifiedTime);
      if (section) updatePropertyTag('article:section', section);
      if (tag) updatePropertyTag('article:tag', tag);
      updatePropertyTag('article:author', author);
    }

    // Structured Data / JSON-LD
    const structuredData = {
      "@context": "https://schema.org",
      "@type": type === 'article' ? 'Article' : 'WebPage',
      "name": title,
      "description": description,
      "url": fullUrl,
      "image": fullImageUrl,
      "author": {
        "@type": "Organization",
        "name": author
      },
      "publisher": {
        "@type": "Organization",
        "name": "Aedon Community",
        "logo": {
          "@type": "ImageObject",
          "url": "https://aedoncommunity.com/aedon.png"
        }
      },
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": fullUrl
      },
      "datePublished": publishedTime || new Date().toISOString(),
      "dateModified": modifiedTime || new Date().toISOString(),
      "inLanguage": "tr-TR",
      "isPartOf": {
        "@type": "WebSite",
        "name": "Aedon Community",
        "url": "https://aedoncommunity.com"
      }
    };

    // Mevcut structured data script'ini kaldır
    const existingScript = document.querySelector('script[type="application/ld+json"]');
    if (existingScript) {
      existingScript.remove();
    }

    // Yeni structured data script'i ekle
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

  }, [title, description, keywords, fullUrl, fullImageUrl, type, author, publishedTime, modifiedTime, section, tag]);

  return null; // Bu bileşen sadece SEO için kullanılır, render etmez
};

export default SEO; 